require('./devicesView.scss');

const React = require('react');
import PropTypes from 'prop-types';
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');


const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKHeaderSubPage } = require("commonsComponents/OKHeaderSubPage");
const OKModal = require('components/commons/OKModal/OKModal');

// @components
const { GridDevices } = require('components/devices/gridDevices/gridDevices')

const { hasForgottenDevices } = require('selectors/devices')
const {
    requestAllDevices,
    clearDevices,
    requestDevices,
    validateAgentProfile,
} = require('actions/devices')

// @utilities
const { recordLink } = require("utilities/tagging");

// @constants
const { UNKNOWN_DEVICES, BLOCKED_DEVICES } = require('constants/index');
const { DEVICES_CLOSE, DEVICES_CANCEL } = require("constants/tagging.js");

class DevicesView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            buttonAction: () => null,
            buttonText: "",
            deviceName: "",
            secondaryText: "",
            text: "",
            title: "",
            visible: false
        }

        this.handleButtonClick = this.handleButtonClick.bind(this)
        this.openModal = this.openModal.bind(this)
        this.handleHideModal = this.handleHideModal.bind(this)
    }

    componentDidMount() {
        const { forgotten, requestAllDevices, validateAgentProfile } = this.props;
        requestAllDevices(true);
        if (__CONTACT_CENTER__ && !forgotten) validateAgentProfile();
    }

    componentWillUnmount() {
        this.props.clearDevices()
    }

    handleHideModal() {
        this.setState({ visible: false })

        recordLink(DEVICES_CLOSE, DEVICES_CANCEL)
    }

    openModal(title, text, secondaryText, buttonText, deviceName, buttonAction) {
        this.setState({
            buttonAction: buttonAction,
            buttonText: buttonText,
            deviceName: deviceName,
            secondaryText: secondaryText,
            text: text,
            title: title,
            visible: true
        })
    }

    handleGoToForgottenDevices = () => {
        this.props.history.push("/myprofile/devices/forgotten")
    }

    handleButtonClick() {
        this.state.buttonAction()
        this.handleHideModal()
    }

    showMoreDevices = (type, numberDevices) => {
        switch (type) {
            case UNKNOWN_DEVICES:
                this.props.requestDevices(true, false, numberDevices, true)
                break;
            case BLOCKED_DEVICES:
                this.props.requestDevices(false, true, numberDevices, true)
                break;
            default:
                this.props.requestDevices(false, false, numberDevices, true);
        }
    }

    renderContent = () => {
        const { forgotten, firstTableTitle, firstTableDescription } = this.props
        const gridBlockedTitle = formatText("manageDevices-explanationBlockedTextTitle")
        const gridUnknownTitle = formatText("manageDevices-explanationUnknownTextTitle")

        return (
            <div className="grid-view__body">
                <div className="container-fluid">
                    {/* Normal devices */}
                    <GridDevices
                        openModal={this.openModal}
                        title={firstTableTitle}
                        showEmpty={true}
                        description={firstTableDescription}
                        // key={`${forgotten ? 'forgotten': 'noforgotten'} blocked`}
                        forgotten={forgotten}
                        blocked={false}
                        unknown={false}
                        showMore={this.showMoreDevices}
                    />
                    {/* Unknown devices */}
                    <GridDevices
                        openModal={this.openModal}
                        title={gridUnknownTitle}
                        // key={`${forgotten ? 'forgotten': 'noforgotten'} blocked`}
                        forgotten={forgotten}
                        blocked={false}
                        showMore={this.showMoreDevices}
                        unknown
                    />
                    {/* Blocked devices */}
                    <GridDevices
                        openModal={this.openModal}
                        title={gridBlockedTitle}
                        // key={`${forgotten ? 'forgotten': 'noforgotten'} blocked`}
                        forgotten={forgotten}
                        blocked
                        unknown={false}
                        showMore={this.showMoreDevices}
                    />
                </div>
            </div>
        )
    }

    renderButton = () => {
        const { forgotten, hasForgottenDevices } = this.props
        if (forgotten)
            return null;

        const className = classnames("devices-view__tooltip-div", {
            ['devices-view__tooltip-div--disabled']: !hasForgottenDevices
        })
        const button = (
            <div className={className}>
                <OKButton disabled={!hasForgottenDevices} modifier="secondary" onClick={() => this.handleGoToForgottenDevices()}>
                    <FormattedText value="devicesView-toForgottenDevices" />
                </OKButton>
            </div>
        )

        return (
            !hasForgottenDevices ?
                <OKTooltip
                    content="devicesView-tooltipButton"
                    offset={[0, -15]}
                    target={button}
                /> : button
        )
    }

    render() {
        const { breadcrumb, headerKey, forgotten } = this.props
        const {
            buttonText,
            deviceName,
            secondaryText,
            text,
            title,
            visible
        } = this.state;

        const modalContent = (
            <React.Fragment>
                {deviceName && <div className="devices-view__device-name">{deviceName}</div>}
                <div className="devices-view__primary-text">{text}</div>
                {secondaryText && <div className="devices-view__secondary-text">{secondaryText}</div>}
            </React.Fragment>
        )

        return (
            <div className="devices-view">
                <OKCover extraClass="devices-view__head" size="medium" section={forgotten ? 'dispositives-no-visible' : 'dispositives'}>
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={formatText(headerKey)}
                        isSubtitleLeftCapital={false}
                        overlap={false}
                    >
                        {this.renderButton()}
                    </OKHeaderSubPage>
                </OKCover>
                {this.renderContent()}
                <OKModal
                    content={modalContent}
                    isOpen={visible}
                    footerType="navigation"
                    onCloseCallback={this.handleHideModal}
                    primaryButtonText={buttonText}
                    onPrimaryButtonClick={this.handleButtonClick}
                    onSecondaryButtonClick={this.handleHideModal}
                    overlayClassName="devices-view"
                    secondaryButtonText="manageDevices-cancel"
                    title={title}
                />
            </div>
        );
    }
}

DevicesView.propTypes = {
    forgotten: PropTypes.bool,
    breadcrumb: PropTypes.object,
    headerKey: PropTypes.string,
    history: PropTypes.object.isRequired,
    firstTableTitle: PropTypes.string,
    firstTableDescription: PropTypes.string,
    requestAllDevices: PropTypes.func,
    requestDevices: PropTypes.func,
    clearDevices: PropTypes.func,
    validateAgentProfile: PropTypes.func,
    hasForgottenDevices: PropTypes.bool
};

const mapStateToProps = (state) => ({
    hasForgottenDevices: hasForgottenDevices(state)
})

const mapDispatchToProps = {
    requestAllDevices,
    clearDevices,
    requestDevices,
    validateAgentProfile
}


module.exports.constructor = connect(mapStateToProps, mapDispatchToProps)(withRouter(DevicesView));
module.exports.DevicesView = connect(mapStateToProps, mapDispatchToProps)(withRouter(DevicesView));
